import { TableAreas } from "@components";
import CardCountAreas from "../../components/CardCountAreas";
import PageContainer from "../../components/routes/PageContainer";
import { MapDrawingProvider } from "../../providers/MapDrawingContext";
import AreasCreate from "../areasCreate";
import { useAreasControl } from "./components";

const AreasScreen = () => {
  const {
    showCreate,
    selectedAreaId,
    dashboard,
    areas,
    pages,
    totalSize,
    page,
    searchValue,
    handleCreateNewArea,
    handleOpenArea,
    handleDeleteArea,
    handleSort,
    handleSearchValueChange,
    handlePage,
    handleResetPage,
    handleCancelCreate,
    PAGE_SIZE,
    isLoading,
  } = useAreasControl();

  if (showCreate) {
    return (
      <MapDrawingProvider>
        <AreasCreate areaId={selectedAreaId} onCancel={handleCancelCreate} />
      </MapDrawingProvider>
    );
  }

  return (
    <PageContainer>
      <div className="display-flex gap-20">
        <CardCountAreas
          borderColor="#5CB85C"
          label="ÁREAS DE INTERESSE"
          label1={"todas rotas"}
          value1={dashboard.globalInterests}
          label2={"específicas"}
          value2={dashboard.opcionalInterests}
        />
        <CardCountAreas
          borderColor="#ff0000"
          label="ÁREAS A SEREM EVITADAS"
          label1="todas rotas"
          value1={dashboard.globalAvoids}
          label2={"específicas"}
          value2={dashboard.optinalAvoids}
        />
      </div>

      <TableAreas
        isLoading={isLoading}
        pages={pages}
        pageSize={PAGE_SIZE}
        totalSize={totalSize}
        handleDownload={() => { }}
        handleSort={handleSort}
        areas={areas}
        viewType="TABLE"
        page={page}
        handleCreateArea={handleCreateNewArea}
        handleOpenArea={handleOpenArea}
        handleSearchValueChange={handleSearchValueChange}
        searchValue={searchValue}
        handleDelete={handleDeleteArea}
        handlePage={handlePage}
        handleResetPage={handleResetPage}
      />
    </PageContainer>
  )
}

export default AreasScreen;